import {request} from '../request';
import {PreProcessor} from '../../types/preprocessor/PreProcessor';
import {TransformationType} from '../../types/preprocessor/TransformationType';

export type PreProcessorNewRequest = {
  projectId: string;
  transformationType: TransformationType;
};

export type PreProcessorNewResponse = PreProcessor;

export const PreProcessorNewUrl = ({
  projectId,
  transformationType,
}: PreProcessorNewRequest) =>
  `/preprocessor/new?${new URLSearchParams({
    projectId,
    transformationType,
  }).toString()}`;

export async function preProcessorNew(data: PreProcessorNewRequest) {
  return request<PreProcessorNewResponse>({
    method: 'get',
    url: PreProcessorNewUrl(data),
  });
}
